/**
 * CSV download with proper quoting and a UTF-8 BOM so Excel shows accents.
 */
export function downloadCsv(filename: string, headers: string[], rows: (string | number | null | undefined)[][]) {
  const escape = (cell: string | number | null | undefined) => `"${String(cell ?? '').replace(/"/g, '""')}"`;
  const content = [headers, ...rows].map((row) => row.map(escape).join(',')).join('\r\n');
  const blob = new Blob(['﻿' + content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function csvFileName(prefix: string, eventName: string) {
  const slug = eventName.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^\w]+/g, '_');
  return `${prefix}_${slug}_${new Date().toISOString().split('T')[0]}.csv`;
}
